"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doubleQuotes = exports.enclose = exports.commaSeparated = exports.join = void 0;
__exportStar(require("fp-ts/string"), exports);
/**
 * Create a Monoid instance to join strings using a separator.
 */
const join = (separator) => ({
    concat: (a, b) => (a === '' || b === '' ? a + b : a + separator + b),
    empty: '',
});
exports.join = join;
/**
 * Monoid instance to join strings using a comma.
 */
exports.commaSeparated = (0, exports.join)(' ');
const enclose = (leading, trailing) => (s) => `${leading}${s}${trailing}`;
exports.enclose = enclose;
exports.doubleQuotes = (0, exports.enclose)('"', '"');
//# sourceMappingURL=string.js.map